/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    rounded: { type: 'variant', values: [ true, false ] },
    size: { type: 'variant', values: [ 'small' ] }
  },
  rules: [
    {
      if: { size: 'small' },
      tokens: { paddingBottom: 4, paddingTop: 4 }
    },
    { if: { rounded: true }, tokens: { borderRadius: 4 } }
  ],
  tokens: {
    background: 'rgba(0, 0, 0, 0.05)',
    borderRadius: 0,
    color: '#4b286d',
    gap: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8
  }
}
export default theme
